<template>
    <card>
        <template v-slot:header>Gemeldete Nachrichten</template>
        <template v-slot:action>
            <i v-show="items.length===0" class="fa fa-exclamation-triangle fa-xl text-green-500"></i>
            <i v-show="items.length!==0" class="fa fa-exclamation-triangle fa-xl text-red-500"></i>
        </template>

        <loading v-show="loading"></loading>

        <div v-show="!loading">
            <p v-show="items.length === 0">Keine Probleme.</p>

            <tailwind-table v-show="items.length > 0" :header="['Schreibtisch', 'Melder', 'Nachricht', '']">
                <tr v-for="item in items">
                    <td class="px-6 py-3">{{ item.desk.name }}</td>
                    <td class="px-6 py-3">{{ item.user.name }}</td>
                    <td class="px-6 py-3">{{ item.note }}</td>
                    <td>
                        <button-white><a href="/admin/pages/error_messages">Buchung aufrufen</a></button-white>

                    </td>
                </tr>
            </tailwind-table>
        </div>
    </card>
</template>

<script>
import Card from "./UI/Card";
import Loading from "./UI/Loading";
import TailwindTable from "./UI/TailwindTable";
import ConfirmDialog from "./UI/ConfirmDialog";
import ButtonWhite from "./UI/ButtonWhite";

export default {
    name: "ScheduleErrors",
    components: {ButtonWhite, ConfirmDialog, TailwindTable, Loading, Card},

    data: () => ({
        items: [],
        loading: true,
    }),

    mounted() {
        this.load();
    },

    methods: {
        load() {
            this.loading = true;
            window.axios.get('/admin/schedules/error').then(response => {
                this.items = response.data.data;
                this.loading = false;
            })
        },
        fix(item) {
            this.loading = true;
            window.axios.post(`/admin/schedules/${item.id}`, {
                _method: 'put',
                is_resolved: true,
            }).then(() => {
                this.load();
            })
        }
    }
}
</script>

<style scoped>

</style>
